import React, { useState } from 'react';

const StartupRegistration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Startup registration.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with Startup registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Startup Registration
            </h1>
            <p className="mt-4 text-xl text-blue-100">
              From DPIIT recognition to company incorporation, we handle the entire startup registration process — helping you launch faster, stay compliant, and unlock exclusive Startup India benefits.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">📈</span> Empowering Your Startup Journey.
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Startup Registration
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                A startup is a newly established business, usually small, started by one or a group of individuals with innovation. The business either develops a new product/ service or redevelops a current product/service into something better.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                The process involves incorporating your startup (as a private company, LLP, or partnership), then obtaining DPIIT recognition through a simple online application. Recognition validates your business as a government-supported startup, making you eligible for special incentives and resources.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Startup registration in India is a transparent, mostly online process centered on the Startup India and DPIIT (Department for Promotion of Industry and Internal Trade) platforms.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Tax Exemptions:</strong> Eligible startups can access an income tax holiday for three consecutive years within their first ten years, and exemptions from capital gains and investments above fair market value.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Easier Funding:</strong> Access to dedicated government funds, venture capital, and fast-track approvals for equity investments, making fundraising simpler.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Government Tenders:</strong> Registered startups can apply for government tenders without prior experience or turnover criteria. This opens large business opportunities previously inaccessible to new firms.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Compliance Relaxation:</strong> Simplified compliance and self-certification for labor and environmental laws, reducing operational burden.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Networking & Global Exposure:</strong> Inclusion in national and international platforms, access to mentorship, and opportunities to participate in innovation challenges and industry events.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">IP and Patent Support:</strong> Startups enjoy fast-tracked patent examination and up to 80% rebate on filing fees for patents and trademarks, along with expert IP support.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Other Perks:</strong> Subsidized incubation, easier winding down of business ("fast exit"), and integration with state-level startup policies.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                <input type="text" name="website_hp" value={formData.website_hp} onChange={handleInputChange} style={{ display: 'none' }}/>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Startup registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Startup Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📊", title: "Choose Your Legal Structure", desc: "Decide if your business will be a Private Limited Company, Limited Liability Partnership (LLP), or Partnership Firm." },
              { number: "02", icon: "🔒", title: "Incorporate the Entity", desc: "File for incorporation with the Ministry of Corporate Affairs (MCA) or Registrar, get your Certificate of Incorporation, PAN, and TAN." },
              { number: "03", icon: "🏢", title: "Register on Startup India Portal", desc: "Create an account on the Startup India portal (startupindia.gov.in) and complete your company profile." },
              { number: "04", icon: "📄", title: "Apply for DPIIT Recognition", desc: "After logging in, submit an application for DPIIT Startup Recognition, filling out all required forms." },
              { number: "05", icon: "✍️", title: "Prepare and Upload Documents", desc: "Submit necessary documents like incorporation certificate, PAN, Aadhaar, address proof, business description, and pitch deck (if available)." },
              { number: "06", icon: "💡", title: "Provide Innovation Details", desc: "Detail your business innovation or unique value by uploading a pitch deck, website URL, product demo, or supporting pitch documents." },
              { number: "07", icon: "🖋️", title: "Self-Certification and Declarations", desc: "Self-certify adherence to Startup India eligibility criteria and compliance with relevant laws, including labor and environmental standards." },
              { number: "08", icon: "📜", title: "Obtain Startup Certificate", desc: "Receive your DPIIT Recognition Certificate, enabling access to all Startup India benefits and incentives." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Startup Registration
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "📋", title: "Certificate of Incorporation/Registration", desc: "First, we get the Incorporation/Registration Certificate of your startup from MCA/Registrar of Firms." },
              { icon: "🆔", title: "Identity Proof", desc: "PAN card (Company, Founders, Partners), Aadhaar Card & Passport size photographs of Directors / Founders" },
              { icon: "🏢", title: "Address Proof of Company", desc: "Business address proof (rent agreement, utility bill, etc.), Ownership papers of the registered office (if owned) or a rent/lease agreement and No Objection Certificate (NOC) from the landlord (if rented)." },
              { icon: "💡", title: "Proof of Concept", desc: "Proof of concept like pitch deck/website link/video (in case of a validation/ early traction/scaling stage startup)." },
              { icon: "🏷️", title: "MSME/Udyam Certificate", desc: "MSME/Udyam certificate (if available)." },
              { icon: "⚖️", title: "Patent and Trademark Details", desc: "While submitting Start-Up Registration, patent and trademark details is optional. But it's recommended to take it earliest to safeguard business interest." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "📋", title: "Incorporation Certificate", desc: "Incorporation Certificate and other belongings depends upon business structures package Selection." },
              { icon: "📜", title: "Certificate of DPIIT Recognition", desc: "An official digital certificate confirming your business's status as a recognized startup under the Startup India and DPIIT framework. This is your 'entry pass' to all related incentives and schemes." },
              { icon: "💰", title: "Access to Government Schemes and Funding", desc: "Eligibility to participate in government seed fund schemes, venture funding, and grants earmarked for startups by various ministries." },
              { icon: "🏆", title: "IP Certificates", desc: "For patents or trademarks filed post-registration." },
              { icon: "🛡️", title: "Additional Benefits", desc: "Tax Exemptions, Easier Public Procurement, IPR and Legal Support, Simple Compliance and Self-Certification, Incubation and R&D Benefits" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      Startup FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">What is Startup India registration?</h4>
                      <p className="text-gray-600">Startup India registration is an official government process for recognizing new, innovative businesses. Once recognized, you become eligible for tax exemptions, funding schemes, and various benefits under the DPIIT (Department for Promotion of Industry and Internal Trade).</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">Who can register as a startup?</h4>
                      <p className="text-gray-600">Any business registered as a Private Limited Company, LLP, or Partnership Firm, incorporated within the last 10 years, with annual turnover under INR 100 crore, and engaged in innovation or improvement of products or services.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">Can LLPs and Partnership Firms apply?</h4>
                      <p className="text-gray-600">Yes, LLPs and Partnership firms as well as Private Limited Companies qualify for Startup registration, provided they meet all other eligibility criteria.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">How long does the recognition process take?</h4>
                      <p className="text-gray-600">Typically, DPIIT approval may take from 2 to 4 weeks after a complete application is submitted.</p>
                  </div>
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready to Startup Registration?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of advisors simplify your Startup Registration journey.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default StartupRegistration;